// src/components/ReporteBajaSTPDF.js

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const AZUL = "#328AC4";

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 115,
    fontSize: 6,
    fontFamily: "Helvetica",
    color: "#252525",
  },

  logoContainer: {
    marginBottom: 6,
  },

  logo: {
    width: 120,
  },

  titleContainer: {
    alignItems: "center",
    marginBottom: 15,
  },

  title: {
    fontSize: 14,
    fontWeight: "bold",
    color: AZUL,
    textAlign: "center",
  },

  subtitle: {
    marginTop: 3,
    fontSize: 8,
    color: "#666666",
    textAlign: "center",
  },

  sectionHeader: {
    marginTop: 5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottom: `0.7pt solid ${AZUL}`,
  },

  sectionTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: AZUL,
  },

  table: {
    marginBottom: 9,
    border: "0.7pt solid #D5DCE3",
    borderRadius: 3,
    overflow: "hidden",
  },

  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#EEF3F7",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.5pt solid #D5DCE3",
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.3pt solid #E8E8E8",
  },

  // CLIENTE
  colRut: {
    width: "10%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colNombre: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colFecha: {
    width: "14%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTelefono: {
    width: "11%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colDireccion: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colEmail: {
    width: "19%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colNacimiento: {
    width: "10%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // EQUIPO
  colFamilia: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colTipo: {
    width: "22%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colMarca: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colModelo: {
    width: "16%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colSerie: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colServicio: {
    width: "14%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colHora: {
    width: "4%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // TABLAS GENERALES
  colNumero: {
    width: "5%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colItem: {
    width: "70%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colResultado: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 4,
  },

  // MEDICIONES
  colMedItem: {
    width: "40%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colMedValor: {
    width: "20%",
    textAlign: "center",
    paddingHorizontal: 3,
  },

  colMedUnidad: {
    width: "20%",
    textAlign: "center",
    paddingHorizontal: 3,
  },

  colMedRango: {
    width: "15%",
    textAlign: "center",
    paddingHorizontal: 3,
  },

  // RESOLUCIÓN
  resolutionBox: {
    marginBottom: 9,
    padding: 7,
    backgroundColor: "#F7FAFC",
    borderLeft: `3pt solid ${AZUL}`,
    borderRadius: 2,
  },

  resolutionTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: AZUL,
    marginBottom: 4,
  },

  resolutionText: {
    fontSize: 8,
    lineHeight: 1.45,
    textAlign: "justify",
  },

  // OBSERVACIONES
  observationBox: {
    marginBottom: 9,
    padding: 7,
    border: "0.8pt solid #D5DCE3",
    borderRadius: 3,
    backgroundColor: "#FAFAFA",
  },

  observationText: {
    fontSize: 8,
    lineHeight: 1.5,
    textAlign: "justify",
  },

  // DECLARACIÓN
  declarationBox: {
    marginBottom: 9,
    padding: 7,
    backgroundColor: "#F7FAFC",
    borderLeft: `3pt solid ${AZUL}`,
    borderRadius: 2,
  },

  declarationText: {
    fontSize: 7.5,
    lineHeight: 1.45,
    textAlign: "justify",
  },

  // FIRMA - ubicada sobre el footer de la última página
  signatureSection: {
    position: "absolute",
    bottom: 48,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  signatureBox: {
    width: 190,
    alignItems: "center",
  },

  signatureLine: {
    width: 160,
    borderTop: "0.8pt solid #555555",
    marginBottom: 5,
  },

  signatureName: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },

  signatureRole: {
    fontSize: 7,
    marginTop: 2,
    textAlign: "center",
  },

  signatureArea: {
    fontSize: 7,
    color: "#666666",
    marginTop: 1,
    textAlign: "center",
  },

  noData: {
    fontSize: 7,
    color: "#777777",
    fontStyle: "italic",
    padding: 6,
  },

  // FOOTER
  footer: {
    position: "absolute",
    bottom: 14,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6.5,
    color: "#777777",
    borderTop: "0.5pt solid #DDDDDD",
    paddingTop: 4,
  },

  footerContact: {
    width: "80%",
  },

  footerPage: {
    width: "20%",
    textAlign: "right",
  },
});

const textoSeguro = (valor, fallback = "-") => {
  if (
    valor === null ||
    valor === undefined ||
    valor === ""
  ) {
    return fallback;
  }

  return String(valor);
};

const formatearFecha = (fecha, incluirHora = true) => {
  if (!fecha) return "------";

  try {
    let dateObj;

    if (typeof fecha?.toDate === "function") {
      dateObj = fecha.toDate();
    } else if (fecha instanceof Date) {
      dateObj = fecha;
    } else {
      dateObj = new Date(fecha);
    }

    if (Number.isNaN(dateObj.getTime())) {
      return "------";
    }

    return moment(dateObj).format(
      incluirHora
        ? "DD/MM/YYYY HH:mm"
        : "DD/MM/YYYY"
    );
  } catch {
    return "------";
  }
};

const SectionTitle = ({ children }) => (
  <View
    style={styles.sectionHeader}
    minPresenceAhead={35}
  >
    <Text style={styles.sectionTitle}>
      {children}
    </Text>
  </View>
);

const SeccionSimple = ({ titulo, items }) => {
  if (!items?.length) return null;

  return (
    <>
      <SectionTitle>{titulo}</SectionTitle>

      <View style={styles.table}>
        <View style={styles.tableHeader} fixed>
          <Text style={styles.colNumero}>
            N°
          </Text>

          <Text style={styles.colItem}>
            Ítem
          </Text>

          <Text style={styles.colResultado}>
            Resultado
          </Text>
        </View>

        {items.map((item, index) => (
          <View
            style={styles.tableRow}
            key={item.id || item.item_id || index}
            wrap={false}
          >
            <Text style={styles.colNumero}>
              {index + 1}
            </Text>

            <Text style={styles.colItem}>
              {textoSeguro(item.item)}
            </Text>

            <Text style={styles.colResultado}>
              {textoSeguro(
                item.valor,
                "Realizado"
              )}
            </Text>
          </View>
        ))}
      </View>
    </>
  );
};

const SeccionMediciones = ({ items }) => {
  if (!items?.length) return null;

  return (
    <>
      <SectionTitle>
        Mediciones efectuadas
      </SectionTitle>

      <View style={styles.table}>
        <View style={styles.tableHeader} fixed>
          <Text style={styles.colNumero}>
            N°
          </Text>

          <Text style={styles.colMedItem}>
            Medición
          </Text>

          <Text style={styles.colMedValor}>
            Resultado
          </Text>

          <Text style={styles.colMedUnidad}>
            Unidad
          </Text>

          <Text style={styles.colMedRango}>
            Rango
          </Text>
        </View>

        {items.map((item, index) => {
          const tieneRango =
            Number(item.inicial) !== 0 ||
            Number(item.final) !== 0;

          const rango = tieneRango
            ? `${textoSeguro(
                item.inicial,
                ""
              )} - ${textoSeguro(
                item.final,
                ""
              )}`
            : "-";

          return (
            <View
              style={styles.tableRow}
              key={item.id || item.item_id || index}
              wrap={false}
            >
              <Text style={styles.colNumero}>
                {index + 1}
              </Text>

              <Text style={styles.colMedItem}>
                {textoSeguro(item.item)}
              </Text>

              <Text style={styles.colMedValor}>
                {textoSeguro(item.valor)}
              </Text>

              <Text style={styles.colMedUnidad}>
                {textoSeguro(item.medida)}
              </Text>

              <Text style={styles.colMedRango}>
                {rango}
              </Text>
            </View>
          );
        })}
      </View>
    </>
  );
};

const ReporteBajaSTPDF = ({
  ingreso = null,
  presupuestoCab = null,
  presupuesto = [],
  bitacoraCab = null,
  bitacora = [],
  baja = null,
  usuario = [],
  empresa = "",
}) => {
  const porCategoria = (lista, categoria) =>
    lista.filter(
      (item) =>
        String(
          item?.categoria || ""
        ).toUpperCase() === categoria
    );

  const irreparables = porCategoria(
    presupuesto,
    "IRREPARABLE"
  );

  const servicios = porCategoria(
    presupuesto,
    "SERVICIO"
  );

  const checks = porCategoria(
    bitacora,
    "CHECK"
  );

  const mediciones = porCategoria(
    bitacora,
    "MEDICION"
  );

  const seguridad = porCategoria(
    bitacora,
    "SEGURIDAD"
  );

  const instrumentos = porCategoria(
    bitacora,
    "INSTRUMENTOS"
  );

  const tecnico = Array.isArray(usuario)
    ? usuario[0]
    : usuario;

  const nombreTecnico = tecnico
    ? `${tecnico?.nombre ?? ""} ${
        tecnico?.apellido ?? ""
      }`.trim()
    : "";

  const fechaResolucion =
    baja?.fechabaja ||
    presupuestoCab?.fecha_baja ||
    bitacoraCab?.fechamod ||
    bitacoraCab?.fechaadd ||
    ingreso?.fecha_out;

  const observaciones =
    bitacoraCab?.observaciones ||
    baja?.observaciones ||
    "Sin observaciones.";

  const motivoBaja =
    baja?.irreparable ||
    irreparables?.[0]?.item ||
    "Condición técnica determinada como irreparable.";

  return (
    <Document>
      <Page
        size="LETTER"
        style={styles.page}
        wrap
      >
        {/* LOGO */}
        {!!empresa && (
          <View style={styles.logoContainer}>
            <Image
              src={`../../${empresa}.png`}
              style={styles.logo}
            />
          </View>
        )}

        {/* TÍTULO */}
        <View style={styles.titleContainer}>
          <Text style={styles.title}>
            CERTIFICADO TÉCNICO DE BAJA
          </Text>

          {!!ingreso?.folio && (
            <Text style={styles.subtitle}>
              Orden de servicio N°{" "}
              {ingreso.folio}
            </Text>
          )}
        </View>

        {/* INFORMACIÓN DEL CLIENTE */}
        <SectionTitle>
          Información del cliente
        </SectionTitle>

        <View
          style={styles.table}
          wrap={false}
        >
          <View style={styles.tableHeader}>
            <Text style={styles.colRut}>
              RUT
            </Text>

            <Text style={styles.colNombre}>
              Nombre
            </Text>

            <Text style={styles.colFecha}>
              Fecha
            </Text>

            <Text style={styles.colTelefono}>
              Teléfono
            </Text>

            <Text style={styles.colDireccion}>
              Dirección
            </Text>

            <Text style={styles.colEmail}>
              Email
            </Text>

            <Text style={styles.colNacimiento}>
              F. Nac.
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.colRut}>
              {textoSeguro(
                ingreso?.rut,
                ""
              )}
            </Text>

            <Text style={styles.colNombre}>
              {textoSeguro(
                ingreso?.entidad,
                ""
              )}
            </Text>

            <Text style={styles.colFecha}>
              {formatearFecha(
                ingreso?.date
              )}
            </Text>

            <Text style={styles.colTelefono}>
              {textoSeguro(
                ingreso?.telefono,
                ""
              )}
            </Text>

            <Text style={styles.colDireccion}>
              {textoSeguro(
                ingreso?.direccion,
                ""
              )}
            </Text>

            <Text style={styles.colEmail}>
              {textoSeguro(
                ingreso?.correo,
                ""
              )}
            </Text>

            <Text style={styles.colNacimiento}>
              {ingreso?.fnaci
                ? formatearFecha(
                    ingreso.fnaci,
                    false
                  )
                : "------"}
            </Text>
          </View>
        </View>

        {/* INFORMACIÓN DEL EQUIPO */}
        <SectionTitle>
          Información del equipo
        </SectionTitle>

        <View
          style={styles.table}
          wrap={false}
        >
          <View style={styles.tableHeader}>
            <Text style={styles.colFamilia}>
              Familia
            </Text>

            <Text style={styles.colTipo}>
              Tipo
            </Text>

            <Text style={styles.colMarca}>
              Marca
            </Text>

            <Text style={styles.colModelo}>
              Modelo
            </Text>

            <Text style={styles.colSerie}>
              Serie
            </Text>

            <Text style={styles.colServicio}>
              Servicio
            </Text>

            <Text style={styles.colHora}>
              Hora
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.colFamilia}>
              {textoSeguro(
                ingreso?.familia,
                ""
              )}
            </Text>

            <Text style={styles.colTipo}>
              {textoSeguro(
                ingreso?.tipo,
                ""
              )}
            </Text>

            <Text style={styles.colMarca}>
              {textoSeguro(
                ingreso?.marca,
                ""
              )}
            </Text>

            <Text style={styles.colModelo}>
              {textoSeguro(
                ingreso?.modelo,
                ""
              )}
            </Text>

            <Text style={styles.colSerie}>
              {textoSeguro(
                ingreso?.serie,
                ""
              )}
            </Text>

            <Text style={styles.colServicio}>
              {textoSeguro(
                ingreso?.servicio,
                ""
              )}
            </Text>

            <Text style={styles.colHora}>
              {ingreso?.horamaquina ?? ""}
            </Text>
          </View>
        </View>

        {/* RESOLUCIÓN TÉCNICA */}
        <SectionTitle>
          Resolución Técnica
        </SectionTitle>

        <View
          style={styles.resolutionBox}
          wrap={false}
        >
          <Text style={styles.resolutionTitle}>
            Resolución: BAJA DE SERVICIO
            TÉCNICO
          </Text>

          <Text style={styles.resolutionText}>
            De acuerdo con la evaluación y
            las pruebas técnicas efectuadas al
            equipo identificado en este
            documento, se determina su Baja de
            Servicio Técnico.
          </Text>

          <Text
            style={[
              styles.resolutionText,
              { marginTop: 5 },
            ]}
          >
            Motivo técnico:{" "}
            {textoSeguro(motivoBaja)}
          </Text>

          <Text
            style={[
              styles.resolutionText,
              { marginTop: 5 },
            ]}
          >
            Fecha de resolución:{" "}
            {formatearFecha(
              fechaResolucion
            )}
          </Text>
        </View>

        {/* SERVICIOS */}
        {servicios.length > 0 && (
          <>
            <SectionTitle>
              Servicio Técnico Asociado
            </SectionTitle>

            <View style={styles.table}>
              <View
                style={styles.tableHeader}
                fixed
              >
                <Text style={styles.colNumero}>
                  N°
                </Text>

                <Text
                  style={[
                    styles.colItem,
                    { width: "95%" },
                  ]}
                >
                  Servicio
                </Text>
              </View>

              {servicios.map(
                (item, index) => (
                  <View
                    style={styles.tableRow}
                    key={
                      item.id ||
                      item.item_id ||
                      index
                    }
                    wrap={false}
                  >
                    <Text
                      style={styles.colNumero}
                    >
                      {index + 1}
                    </Text>

                    <Text
                      style={[
                        styles.colItem,
                        { width: "95%" },
                      ]}
                    >
                      {textoSeguro(
                        item.item
                      )}
                    </Text>
                  </View>
                )
              )}
            </View>
          </>
        )}

        {/* EVIDENCIA TÉCNICA */}
        <SectionTitle>
          Evidencia Técnica
        </SectionTitle>

        {checks.length === 0 &&
          mediciones.length === 0 &&
          seguridad.length === 0 &&
          instrumentos.length === 0 && (
            <View
              style={styles.table}
              wrap={false}
            >
              <Text style={styles.noData}>
                No se registraron ítems
                técnicos adicionales.
              </Text>
            </View>
          )}

        <SeccionSimple
          titulo="Checklist Técnico"
          items={checks}
        />

        <SeccionMediciones
          items={mediciones}
        />

        <SeccionSimple
          titulo="Verificaciones de seguridad"
          items={seguridad}
        />

        <SeccionSimple
          titulo="Instrumentos utilizados"
          items={instrumentos}
        />

        {/* OBSERVACIONES */}
        <SectionTitle>
          Observaciones Técnicas
        </SectionTitle>

        <View style={styles.observationBox}>
          <Text style={styles.observationText}>
            {textoSeguro(
              observaciones,
              "Sin observaciones."
            )}
          </Text>
        </View>

        {/* DECLARACIÓN */}
        <View style={styles.declarationBox}>
          <Text style={styles.declarationText}>
            La presente resolución corresponde
            a una determinación técnica interna
            de LogisticMed Servicio Técnico. A
            partir de esta resolución,
            LogisticMed Servicio Técnico no
            continuará realizando servicios
            técnicos sobre el equipo
            identificado en este certificado.
          </Text>

          <Text
            style={[
              styles.declarationText,
              { marginTop: 5 },
            ]}
          >
            Esta resolución no impide al
            propietario solicitar evaluación,
            diagnóstico o reparación del
            equipo por parte de otro servicio
            técnico o tercero.
          </Text>
        </View>

        {/* FIRMA - SOLO ÚLTIMA PÁGINA */}
        <View
          style={styles.signatureSection}
          wrap={false}
        >
          <View style={styles.signatureBox}>
            <View
              style={styles.signatureLine}
            />

            <Text style={styles.signatureName}>
              {(
                nombreTecnico ||
                textoSeguro(
                  bitacoraCab?.usermod,
                  ""
                )
              ).toUpperCase()}
            </Text>

            <Text style={styles.signatureRole}>
              Técnico responsable
            </Text>

            <Text style={styles.signatureArea}>
              Servicio Técnico
            </Text>
          </View>
        </View>

        {/* FOOTER - TODAS LAS PÁGINAS */}
        <View
          style={styles.footer}
          fixed
        >
          <Text style={styles.footerContact}>
            soporte@dormirbien.cl | General
            Parra #674 Oficina H, Providencia |
            +56 9 7632 1481 / +56 9 5423 4538
          </Text>

          <Text
            style={styles.footerPage}
            render={({
              pageNumber,
              totalPages,
            }) =>
              `Página ${pageNumber} de ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

export default ReporteBajaSTPDF;